'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _seller = require('./remote/seller');

var Seller = {
    fetchSellers: _seller.SellerRemote.fetchSellers,
    fetchSellersByIds: _seller.SellerRemote.fetchSellersByIds,
    postFollow: _seller.SellerRemote.postFollow,
    postMessage: _seller.SellerRemote.postMessage,
    postUnfollow: _seller.SellerRemote.postUnfollow
};

exports.default = Seller;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/seller.js
// module id = yM+3
// module chunks = 57